// Author YuJiaBei
// Date 2023-10-19 14:29:03

class SithMesPrdProjectPlanDetailPpd {
constructor({
        id = null,
        parentId = '',
        ppdIdPrp = '',
        ppdIdPpt = '',
        ppdIdParentPpt = '',
        ppdIdMachineType = '',
        ppdType = '',
        level = '',
        ppdLevelPpt = '',
        ppdActivityId = '',
        name = '',
        ppdChineseDescription = '',
        ppdDuration = '',
        missionMode = '',
        ppdPredecessor = '',
        ppdAutoCalculate = '',
        ppdEnable = '',
        ppdBufferTime = '',
        ppdMilestoneCode = '',
        seq = '',
        nodeCode = '',
        status = '',
        ppdWbsNumber = '',
        ppdPriority = '',
        ppdBaselineAStartTime = '',
        ppdBaselineAEndTime = '',
        ppdBaselineBStartTime = '',
        ppdBaselineBEndTime = '',
        ppdOmForecastStartTime = '',
        ppdOmForecastEndTime = '',
        ppdPpForecastStartTime = '',
        ppdPpForecastEndTime = '',
        ppdActualStartTime = '',
        ppdActualEndTime = '',
        ppdLastStartTime = '',
        ppdLastEndTime = '',
        ppdBaselineStartDeviation = '',
        ppdBaselineEndDeviation = '',
        ppdOmPpStartDeviation = '',
        ppdOmPpEndDeviation = '',
        ppdOmAclStartDeviation = '',
        ppdOmAclEndDeviation = '',
        ppdBaseAclStartDeviation = '',
        ppdBaseAclEndDeviation = '',
        mainProjectBeginTime = '',
        mainProjectEndTime = '',
        mainOmBeginDeviation = '',
        mainOmEndDeviation = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.ppdIdPrp = ppdIdPrp;
    this.ppdIdPpt = ppdIdPpt;
    this.ppdIdParentPpt = ppdIdParentPpt;
    this.ppdIdMachineType = ppdIdMachineType;
    this.ppdType = ppdType;
    this.level = level;
    this.ppdLevelPpt = ppdLevelPpt;
    this.ppdActivityId = ppdActivityId;
    this.name = name;
    this.ppdChineseDescription = ppdChineseDescription;
    this.ppdDuration = ppdDuration;
    this.missionMode = missionMode;
    this.ppdPredecessor = ppdPredecessor;
    this.ppdAutoCalculate = ppdAutoCalculate;
    this.ppdEnable = ppdEnable;
    this.ppdBufferTime = ppdBufferTime;
    this.ppdMilestoneCode = ppdMilestoneCode;
    this.seq = seq;
    this.nodeCode = nodeCode;
    this.status = status;
    this.ppdWbsNumber = ppdWbsNumber;
    this.ppdPriority = ppdPriority;
    this.ppdBaselineAStartTime = ppdBaselineAStartTime;
    this.ppdBaselineAEndTime = ppdBaselineAEndTime;
    this.ppdBaselineBStartTime = ppdBaselineBStartTime;
    this.ppdBaselineBEndTime = ppdBaselineBEndTime;
    this.ppdOmForecastStartTime = ppdOmForecastStartTime;
    this.ppdOmForecastEndTime = ppdOmForecastEndTime;
    this.ppdPpForecastStartTime = ppdPpForecastStartTime;
    this.ppdPpForecastEndTime = ppdPpForecastEndTime;
    this.ppdActualStartTime = ppdActualStartTime;
    this.ppdActualEndTime = ppdActualEndTime;
    this.ppdLastStartTime = ppdLastStartTime;
    this.ppdLastEndTime = ppdLastEndTime;
    this.ppdBaselineStartDeviation = ppdBaselineStartDeviation;
    this.ppdBaselineEndDeviation = ppdBaselineEndDeviation;
    this.ppdOmPpStartDeviation = ppdOmPpStartDeviation;
    this.ppdOmPpEndDeviation = ppdOmPpEndDeviation;
    this.ppdOmAclStartDeviation = ppdOmAclStartDeviation;
    this.ppdOmAclEndDeviation = ppdOmAclEndDeviation;
    this.ppdBaseAclStartDeviation = ppdBaseAclStartDeviation;
    this.ppdBaseAclEndDeviation = ppdBaseAclEndDeviation;
    this.mainProjectBeginTime = mainProjectBeginTime;
    this.mainProjectEndTime = mainProjectEndTime;
    this.mainOmBeginDeviation = mainOmBeginDeviation;
    this.mainOmEndDeviation = mainOmEndDeviation;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdProjectPlanDetailPpd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.id',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdIdPrp',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdIdPrp',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdChineseDescription',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdChineseDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.missionMode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '自动计划' },
                            { value: '2', text: '手动计划' }
            ]
                }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.projectCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.projectName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.network',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prpPriority',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.prpPriority',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdIdPpt',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdIdPpt',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdIdParentPpt',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdIdParentPpt',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdIdMachineType',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdIdMachineType',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdType',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdType',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'level',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdLevelPpt',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdLevelPpt',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdActivityId',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdDuration',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdDuration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdPredecessor',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdPredecessor',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdAutoCalculate',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdAutoCalculate',
        sortable: true,
            isDetail: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdEnable',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBufferTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBufferTime',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdMilestoneCode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdMilestoneCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.seq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectStatusTranslate',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.projectStatusTranslate',
        sortable: true,
            translateFromField: 'projectStatus',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.statusName',
        sortable: true,
            translateFromField: 'status',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdWbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdWbsNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdPriority',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdPriority',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineAStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineAStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineAEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineAEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineBStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineBStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineBEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineBEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmForecastStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmForecastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdPpForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdPpForecastStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdPpForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdPpForecastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdActualStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdActualStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdActualEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdActualEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdLastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdLastStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdLastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdLastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineStartDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaselineEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaselineEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmPpStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmPpStartDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmPpEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmPpEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmAclStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmAclStartDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmAclEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdOmAclEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaseAclStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaseAclStartDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdBaseAclEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.ppdBaseAclEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainProjectBeginTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.mainProjectBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainProjectEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.mainProjectEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainOmBeginDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.mainOmBeginDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainOmEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.mainOmEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    parentIdFilter : '',
    projectCodeFilter : '',
    ppdIdPrpFilter : '',
    ppdIdPrpInFilter : [],
    ppdIdPptFilter : '',
    ppdIdParentPptFilter : '',
    ppdIdMachineTypeFilter : '',
    ppdTypeFilter : '',
    levelFilter : '',
    ppdLevelPptFilter : '',
    ppdActivityIdFilter : '',
    nameFilter : '',
    ppdChineseDescriptionFilter : '',
    ppdDurationFilter : '',
    missionModeFilter : '',
    ppdPredecessorFilter : '',
    ppdAutoCalculateFilter : '',
    ppdEnableFilter : '',
    ppdBufferTimeFilter : '',
    ppdMilestoneCodeListFilter : [],
    ppdMilestoneCodeIsNotNullFilter : '',
    seqFilter : '',
    nodeCodeFilter : '',
    projectStatusFilter : '',
    statusFilter : '',
    ppdWbsNumberFilter : '',
    ppdPriorityFilter : '',
    ppdBaselineBStartTimeRteFilter : '',
    ppdBaselineBStartTimeLteFilter : '',
    ppdBaselineBEndTimeRteFilter : '',
    ppdBaselineBEndTimeLteFilter : '',
    ppdOmForecastStartTimeRteFilter : '',
    ppdOmForecastStartTimeLteFilter : '',
    ppdOmForecastEndTimeRteFilter : '',
    ppdOmForecastEndTimeLteFilter : '',
    ppdPpForecastStartTimeRteFilter : '',
    ppdPpForecastStartTimeLteFilter : '',
    ppdPpForecastEndTimeRteFilter : '',
    ppdPpForecastEndTimeLteFilter : '',
    ppdActualStartTimeRteFilter : '',
    ppdActualStartTimeLteFilter : '',
    ppdActualEndTimeRteFilter : '',
    ppdActualEndTimeLteFilter : '',
    ppdLastStartTimeRteFilter : '',
    ppdLastStartTimeLteFilter : '',
    ppdLastEndTimeRteFilter : '',
    ppdLastEndTimeLteFilter : '',
    mainProjectBeginTimeRteFilter : '',
    mainProjectBeginTimeLteFilter : '',
    mainProjectEndTimeRteFilter : '',
    mainProjectEndTimeLteFilter : '',
    mainOmBeginDeviationFilter : '',
    mainOmEndDeviationFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdIdPrpFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdIdPrp',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdProjectPlanPrp'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ppdIdMachineTypeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdIdMachineType',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstMachineType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ppdTypeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdType',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActivityIdFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdActivityId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdChineseDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdChineseDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdDurationFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdDuration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'missionModeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.missionMode',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '自动计划' },
                { value: '2', text: '手动计划' }
            ]
        }
        },
        {
        key: 'ppdPredecessorFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPredecessor',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdAutoCalculateFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdAutoCalculate',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdEnableFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBufferTimeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdBufferTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdMilestoneCodeListFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdMilestoneCodeList',
        disabled: false,
        form: {
        type: 'selectMultiple',
        modalMultiSelectedType: 'string'
         ,options: [
                { value: '缸体', text: '缸体' },
                { value: '转子包', text: '转子包' },
                { value: '机组试验', text: '机组试验' },
                { value: '总装配', text: '总装配' },
                { value: '包装', text: '包装' },
                { value: '核心组装', text: '核心组装' },
                { value: '发货', text: '发货' }
            ]
        }
        },
        {
        key: 'ppdMilestoneCodeIsNotNullFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdMilestoneCodeIsNotNull',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectStatusFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.projectStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '商务未释放' },
                { value: '2', text: '设计' },
                { value: '3', text: '采购' },
                { value: '4', text: '生产' },
                { value: '5', text: '暂停' },
                { value: '6', text: '寄存' },
                { value: '7', text: '待发货' },
                { value: '8', text: '已发出' }
            ]
        }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '80', text: '已完成' },
                { value: '70', text: '挂起' },
                { value: '60', text: '生产中' },
                { value: '50', text: '冻结' },
                { value: '40', text: '项目计划' },
                { value: '30', text: '主计划' },
                { value: '20', text: '草拟版' },
                { value: '10', text: '新建' }
            ]
        }
        },
        {
        key: 'ppdWbsNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdWbsNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPriorityFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPriority',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdBaselineBStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdBaselineBStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdBaselineBEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdBaselineBEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdOmForecastStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdOmForecastStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdOmForecastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdOmForecastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPpForecastStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPpForecastStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPpForecastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdPpForecastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdActualStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdActualStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdActualEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdActualEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdLastStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdLastStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdLastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.ppdLastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainProjectBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainProjectBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainProjectEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainProjectEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainOmBeginDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainOmBeginDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainOmEndDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.mainOmEndDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];
const levelTreeFilterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdIdPrp',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdIdPrp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdIdMachineType',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdIdMachineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdType',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdType',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActivityId',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdActivityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdChineseDescription',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdChineseDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdDuration',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'missionMode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.missionMode',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '自动计划' },
                { value: '2', text: '手动计划' }
            ]
        }
        },
        {
        key: 'ppdPredecessor',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdPredecessor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdAutoCalculate',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdAutoCalculate',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdEnable',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBufferTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBufferTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdMilestoneCode',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdMilestoneCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '80', text: '已完成' },
                { value: '70', text: '挂起' },
                { value: '60', text: '生产中' },
                { value: '50', text: '冻结' },
                { value: '40', text: '项目计划' },
                { value: '30', text: '主计划' },
                { value: '20', text: '草拟版' },
                { value: '10', text: '新建' }
            ]
        }
        },
        {
        key: 'ppdWbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdWbsNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPriority',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdPriority',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineAStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineAStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineAEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineAEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineBStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineBEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineBEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmForecastStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmForecastEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdPpForecastStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdPpForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdPpForecastEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdActualStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdActualEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdActualEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdLastStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdLastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdLastEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineStartDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaselineEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaselineEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmPpStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmPpStartDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmPpEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmPpEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmAclStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmAclStartDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdOmAclEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdOmAclEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaseAclStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaseAclStartDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdBaseAclEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.ppdBaseAclEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectBeginTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.mainProjectBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainProjectEndTime',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.mainProjectEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainOmBeginDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.mainOmBeginDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainOmEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.mainOmEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectPlanDetailPpd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdProjectPlanDetailPpd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, levelTreeFilterConfigs


}
